import { IonButton, IonButtons, IonCol, IonContent, IonFooter, IonGrid, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonLoading, IonRow, IonSearchbar, IonTitle, IonToast, IonToolbar, useIonViewDidEnter } from '@ionic/react';
import { arrowBack } from 'ionicons/icons';
import * as Leaflet from 'leaflet';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useGooglePlacesSearch } from '../../../../../components/useGooglePlacesSearch';
import { MessageContext } from '../../../../../contexts/MessageContext';
import { buscarEnderecoTaxa, requestService } from '../../../../../Utils/Services';
import './EnderecoTaxa.css';

type Props = {
  endereco: any;
  inputRef: any;
  closeAction: Function;
  closeActionSimple: Function;
}

const EnderecoTaxa: React.FC<Props> = (props: Props) => {

  const history = useHistory();

  const { loja, setLoja } = useContext(MessageContext);

  const [enderecoSelecionado, setEnderecoSelecionado] = useState<any>("");

  const [textToast, setTextToast] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [showLoading, setShowLoading] = useState(false);

  const [latitudeSelecionado, setLatitudeSelecionado] = useState('');
  const [longitudeSelecionado, setLongitudeSelecionado] = useState('');

  const [taxaEntregaSelecionado, setTaxaEntregaSelecionado] = useState('');
  const [tempoEntregaSelecionado, setTempoEntregaSelecionado] = useState('');

  const [listaTagsEndereco, setListaTagsEndereco] = useState<any>();

  // Flag para evitar busca automática quando preenchemos programaticamente
  const [ignorarProximaMudanca, setIgnorarProximaMudanca] = useState(false);

  let mapa: any = null;
  let mark: any = null;

  const [mapState, setMapState] = useState<any>(null);
  const [markState, setMarkState] = useState<any>(null);

  const [localizacaoState, setLocalizacaoState] = useState<any>(null);

  const { dadosEmpresa, setDadosEmpresa } = useContext(MessageContext);
  const circulosRef = useRef<Leaflet.Circle[]>([]);

  const {
    listaEnderecos,
    buscandoEndereco,
    buscarSugestoes: buscarSugestoesEndereco,
    buscarDetalhes: buscarDetalhesEnderecoHook,
    limparSugestoes
  } = useGooglePlacesSearch({
    loja: loja || "",
    configuracoesEntrega: dadosEmpresa?.configuracoesEntrega || [],
    onError: (mensagem) => {
      setTextToast(mensagem);
      setShowToast(true);
    },
    onLoading: setShowLoading,
    debounceTime: 2000,
    minChars: 4
  });

  let raios = [0.5, 1, 1.5, 2, 2.5, 3, 4, 5, 8, 12];

  const myIcon = new Leaflet.Icon({
    iconUrl: '/assets/pin.svg',
    iconSize: [30, 30],
    popupAnchor: [0, -20]
  });

  useEffect(() => {
    if (props.inputRef.current) {
      props.inputRef.current.focus();
    }
  }, [props.inputRef]);

  // useEffect(() => {

  //   if (props.endereco != "") {
  //     setEnderecoSelecionado(props.endereco);
  //     console.log("entrou no useEffect");
  //   }
  // }, [props.endereco]);

  useEffect(() => {
    const timer = setTimeout(() => {
      loadMap();
      setListaTagsEndereco(dadosEmpresa.tagsEndereco || []);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  useIonViewDidEnter(() => {

  })

  function cadastrar() {
    if (localizacaoState == null || !enderecoSelecionado || !latitudeSelecionado || !longitudeSelecionado) {
      setTextToast('Selecione um local para continuar.');
      setShowToast(true);
    }
    else {
      props.closeAction(enderecoSelecionado, latitudeSelecionado, longitudeSelecionado, taxaEntregaSelecionado, tempoEntregaSelecionado);
    }
  }

  function loadMap() {
    try {
      mapa = Leaflet.map('map').fitWorld();

      Leaflet.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 18,
        attribution: '© OpenStreetMap'
      }).addTo(mapa);

      // mapa.on('locationfound', onLocationFound);

      const localiza = { lat: dadosEmpresa.empresaLatitude, lng: dadosEmpresa.empresaLongitude };
      marcarLocalizacaoMapa(localiza);

      mapa.on('locationerror', onLocationError);

      mapa.on('click', (ev: any) => {
        //mark.setLatLng(ev.latlng);
        //circle.setLatLng(ev.latlng);                
      });

      const localizacao = Leaflet.latLng(
        Number(dadosEmpresa.empresaLatitude),
        Number(dadosEmpresa.empresaLongitude)
      );

      let cores = [
        '#b71c1c', // Vermelho escuro (0.5km)
        '#d32f2f', // Vermelho (1km)
        '#f44336', // Vermelho claro (1.5km)
        '#ff5722', // Laranja avermelhado (2km)
        '#ff9800', // Laranja (2.5km)
        '#ffc107', // Amarelo/dourado (3km)
        '#4caf50', // Verde (4km)
        '#00bcd4', // Ciano (5km)
        '#2196f3', // Azul (8km)
        '#1565c0'  // Azul escuro (12km)
      ];

      circulosRef.current.forEach(circle => circle.remove());
      circulosRef.current = [];

      raios.forEach((raio, index) => {
        let circle = Leaflet.circle(localizacao, {
          color: cores[index],
          fillColor: cores[index],
          fillOpacity: 0.05, // Ajusta a opacidade
          radius: raio * 1000
        }).addTo(mapa);

        circulosRef.current.push(circle);
      });

      mapa.setView(
        [Number(dadosEmpresa.empresaLatitude), Number(dadosEmpresa.empresaLongitude)],
        12
      );

      setMapState(mapa);

    }
    catch (e: any) {
      console.log("deu erro" + e.message);
    }
  }

  function haversine(lat1: number, lon1: number, lat2: number, lon2: number) {
    const R = 6371; // Raio da Terra em km
    const dLat = (lat2 - lat1) * (Math.PI / 180);
    const dLon = (lon2 - lon1) * (Math.PI / 180);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c; // Distância em km
  }

  function marcarLocalizacaoMapa(coordenadas: any) {
    console.log("encontrou a localizacao", coordenadas);

    setLocalizacaoState(coordenadas);

    mark = Leaflet.marker(coordenadas, { icon: myIcon, draggable: true }).addTo(mapa);
    setMarkState(mark);

    mark.on("move", () => {
      const latlng = mark.getLatLng();
      setLocalizacaoState(latlng);
      setLatitudeSelecionado(latlng.lat);
      setLongitudeSelecionado(latlng.lng);


      const distancia = haversine(latlng.lat, latlng.lng, dadosEmpresa.empresaLatitude, dadosEmpresa.empresaLongitude);

      let novoRaioSelecionado: number | null = null;

      if (distancia >= 8 && distancia <= 12) {
        novoRaioSelecionado = 12;
      } else {
        let menorDistancia = Infinity;

        raios.forEach(raio => {
          if (distancia <= raio) {
            const diferenca = Math.abs(distancia - raio);
            if (diferenca < menorDistancia) {
              menorDistancia = diferenca;
              novoRaioSelecionado = raio;
            }
          }
        });
      }

      console.log("novoRaioSelecionado", novoRaioSelecionado);
      if (novoRaioSelecionado !== null) {
        const raioSelecionado = novoRaioSelecionado;
        const configuracoes = [...(dadosEmpresa?.configuracoesEntrega || [])];

        // Ordena por raio em ordem crescente
        configuracoes.sort((a, b) => parseFloat(a.raio) - parseFloat(b.raio));

        const config = configuracoes.find((item: any) => parseFloat(item.raio) >= raioSelecionado);

        console.log("Taxa correspondente:", config?.taxa?.toString() || "");
        setTaxaEntregaSelecionado(config?.taxa?.toString() || "");
      } else {
        console.log("Nenhum raio correspondente encontrado.");
        setTaxaEntregaSelecionado("");
      }

      // console.log("latlng.lat", latlng.lat);
      // console.log("latlng.lng", latlng.lng);
      // console.log("markMatriz", mark.getLatLng());
    })


  }

  function onLocationError(e: any) {
  }

  // Função para buscar detalhes do endereço usando Google Places (apenas quando tipo="raio")
  const buscarDetalhesEndereco = async (placeId: string, enderecoFormatado: string) => {
    try {
      const detalhes = await buscarDetalhesEnderecoHook(placeId, enderecoFormatado);

      // Preencher campos automaticamente (sem disparar busca)
      setIgnorarProximaMudanca(true);
      setEnderecoSelecionado(detalhes.endereco);
      setLatitudeSelecionado(detalhes.latitude);
      setLongitudeSelecionado(detalhes.longitude);

      // Sempre atualizar taxa (mesmo que vazia para fora da área)
      setTaxaEntregaSelecionado(detalhes.taxaEntrega || "");

      // Atualizar mapa
      const novaLocalizacao = Leaflet.latLng(Number(detalhes.latitude), Number(detalhes.longitude));
      if (novaLocalizacao && markState && mapState) {
        markState.setLatLng(novaLocalizacao);
        mapState.setView(novaLocalizacao, 14);
        setLocalizacaoState(novaLocalizacao);
      }

      // Mensagem de sucesso
      if (detalhes.dentroAreaEntrega) {
        setTextToast("Endereço localizado com sucesso.");
      } else {
        setTextToast("Fora da área de entrega.");
      }
      setShowToast(true);

    } catch (error) {
      console.error("Erro ao buscar detalhes:", error);
      // Limpar taxa em caso de erro
      setTaxaEntregaSelecionado("");
    }
  };

  // Handler para seleção de item da lista de sugestões
  const handleSelectItemEndereco = (item: any) => {
    console.log("Item selecionado:", item);

    // Limpar lista de sugestões
    limparSugestoes();

    buscarDetalhesEndereco(item.placeId, item.descricao);
  };


  function buscarLocalizacao(endereco: any) {
    if (endereco.replace(/\s/g, "") == "") {
      setTextToast('Endereço é obrigatório.');
      setShowToast(true);
      return;
    }

    let enderecoTratado = endereco.toLowerCase().replace(/\s/g, "+");
    console.log("enderecoTratado", enderecoTratado);

    const empresaid = loja || "";
    console.log("empresaid", empresaid);

    const urlCompleta = buscarEnderecoTaxa.url.replace("{id}", empresaid.replace(/#/g, '%23')).replace("{endereco}", enderecoTratado);
    console.log("buscarEnderecoTaxa.url", urlCompleta);

    setShowLoading(true);
    requestService(urlCompleta, {

      method: buscarEnderecoTaxa.method,
      headers: [
        ["token", window.localStorage.getItem("token")]
      ],
      credentials: 'include'
    },
      history,
      (response: any) => {
        if (response && response.Item) {
          try {
            setTextToast("Endereço localizado com sucesso.");
            setShowToast(true);

            setEnderecoSelecionado(endereco);
            setLatitudeSelecionado(response.Item.enderecoLat);
            setLongitudeSelecionado(response.Item.enderecoLng);

            setTaxaEntregaSelecionado(response.Item.taxaEntrega);
            setTempoEntregaSelecionado(response.Item.tempoEntrega);


            let novaLocalizacao = Leaflet.latLng(Number(response.Item.enderecoLat), Number(response.Item.enderecoLng));

            if (novaLocalizacao) {
              markState.setLatLng(novaLocalizacao);
              mapState.setView(novaLocalizacao, 14);
              setLocalizacaoState(novaLocalizacao);
            }
          } catch (error) {
            console.log("error", error);
          }

        }
      },
      (error: any) => {
        console.log("e1", error);
        // error.message.message usado quando retorna mais de um endereco
        if (!error.message.mensagemVariosEnderecos) {

          if (error.Item) {
            setEnderecoSelecionado(endereco);
            setLatitudeSelecionado(error.Item.enderecoLat);
            setLongitudeSelecionado(error.Item.enderecoLng);

            setTaxaEntregaSelecionado(error.Item.taxaEntrega);
            setTempoEntregaSelecionado(error.Item.tempoEntrega);

            let novaLocalizacao = Leaflet.latLng(Number(error.Item.enderecoLat), Number(error.Item.enderecoLng));

            if (novaLocalizacao) {
              markState.setLatLng(novaLocalizacao);
              mapState.setView(novaLocalizacao, 14);
              setLocalizacaoState(novaLocalizacao);
            }
          }

          setTextToast(error.message);
          setShowToast(true);
        }
        if (error.message.data) {
          console.log("entrou varios endereços");
          if (Array.isArray(error.message.data) && error.message.data.length > 0) {
            // Comentado: sistema antigo não usa mais setListaEnderecos
            // setListaEnderecos(error.message.data);
          }
        }
      }).finally(() => { setShowLoading(false); });

  }


  return (
    <>

      <IonHeader>
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonIcon slot="icon-only" icon={arrowBack} onClick={() => props.closeActionSimple()} />
          </IonButtons>
          <IonTitle>Endereço</IonTitle>

        </IonToolbar>

        <div style={{ background: "var(--ion-color-primary)", padding: "0px", margin: "0px" }}>
          <IonSearchbar ref={(ref) => props.inputRef.current = ref} value={enderecoSelecionado}
            onIonChange={(e) => {
              const valor = e.detail.value || "";
              setEnderecoSelecionado(valor);

              // Se flag estiver ativa, ignorar busca (foi preenchimento automático)
              if (ignorarProximaMudanca) {
                setIgnorarProximaMudanca(false);
                return;
              }

              // Buscar sugestões apenas para input manual
              buscarSugestoesEndereco(valor);
            }}
            enterkeyhint="search"
            onKeyUp={(e: any) => {
              if (e.key === "Enter") {
                setTimeout(() => {
                  // Forçar busca imediata no Google Places
                  buscarSugestoesEndereco(e.target.value, true);
                }, 100);
              }
            }}

            placeholder="Avenida Paulista, 111, São Paulo"></IonSearchbar>
        </div>

        {listaTagsEndereco && Object.keys(listaTagsEndereco).length > 0 && (
          <IonGrid>
            <IonRow>
              {listaTagsEndereco?.map((opcao: any, index: any) => (
                <IonCol size="auto" key={index}> {/* size="6" coloca 2 botões por linha */}
                  <IonButtons>
                    <IonButton
                      fill="outline"
                      style={{ height: "26px", fontSize: "12px" }}
                      expand="block"
                      shape="round"
                      color="primary"
                      onClick={() => {
                        setEnderecoSelecionado(enderecoSelecionado + opcao);
                        setTimeout(() => {
                          buscarLocalizacao(enderecoSelecionado + opcao);
                        }, 500);
                      }}
                    >
                      {opcao.toUpperCase()}
                    </IonButton>
                  </IonButtons>
                </IonCol>


              ))}
            </IonRow>
          </IonGrid>
        )}

        {listaEnderecos?.length > 0 && (
          <IonList style={{ position: 'absolute', zIndex: 999, backgroundColor: 'white', width: '100%', height: "auto", borderBottom: listaEnderecos.length > 0 ? '1px solid #f1f1f1' : 'none' }}>
            {listaEnderecos.map((item: any, index: any) => (
              <IonItem lines="none" key={"filtro" + index} button onClick={() => handleSelectItemEndereco(item)}>
                <IonLabel>

                  <strong>{item.descricaoPrincipal}</strong>
                  {item.descricaoSecundaria && <div style={{ fontSize: '0.9em', color: '#666' }}>{item.descricaoSecundaria}</div>}

                </IonLabel>
              </IonItem>
            ))}
          </IonList>
        )}

      </IonHeader>
      <IonContent className={"Mapa"}>
        <div style={{ position: "relative", width: "100%", height: "100%" }}>
          <div id="map" style={{ width: "100%", height: "100%" }}></div>
        </div>
      </IonContent>
      <IonFooter className="ion-no-border">
        <IonToolbar>
          <IonButton onClick={() => cadastrar()} expand="block" type="submit">Selecionar</IonButton>
        </IonToolbar>
      </IonFooter>

      <IonToast
        isOpen={showToast}
        position="middle" //top, bottom, middle
        onDidDismiss={() => setShowToast(false)}
        message={textToast}
        duration={3000}
      />

      <IonLoading
        cssClass='my-custom-class'
        isOpen={showLoading}
        onDidDismiss={() => { setShowLoading(false); }}
        spinner='circles'
      />

    </>
  );
};

export default ({ endereco, inputRef, closeAction, closeActionSimple }: { endereco: any, inputRef: any, closeAction: Function, closeActionSimple: Function }) => (
  <EnderecoTaxa endereco={endereco} inputRef={inputRef} closeAction={closeAction} closeActionSimple={closeActionSimple}>
  </EnderecoTaxa>
)
